module.exports = fox._r("fonts/mc_icons-webfont.ttf", __webpack_public_path__ + "_/_/_/root/fonts/pjzlvf8.ttf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/mc_icons-webfont.ttf
// module id = 192
// module chunks = 4